<template>
    <div class="table-responsive">
        <table class="table table-sm table-bordered table-hover">
            <thead class="thead-orange">
                <tr>
                    <th>Creador</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th v-if="!!selectedClient "></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="duty in data.data" :class="{ 'table-success': !!selectedClient  && !!isAssigned(selectedClient , duty.clients) }">
                    <td>{{!!duty.client?duty.client.name: 'SHATTER'}}</td>
                    <td>{{duty.name}}</td>
                    <td>{{duty.description}}</td>
                    <td v-if="!!selectedClient ">
                        <div class="d-flex">
                            <div class="px-1">
                                <button class="btn btn-primary" v-if="!isAssigned(selectedClient , duty.clients)" :disabled="inProgress" @click="toAssign(duty)"><i class="fa fa-check"></i></button>
                            </div>
                            <div class="px-1">
                                <button class="btn btn-danger" v-if="isAssigned(selectedClient , duty.clients)" :disabled="inProgress" @click="unassign(duty)"><i class="fa fa-times"></i></button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <app-paginator 
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        />
    </div>
</template>
<script>
    import Paginator from '../../../../UI/Controls/Paginator/Paginator.vue';
    export default {
        components: {
            appPaginator: Paginator
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            toAssign: {
                type: Function,
                required: true
            },
            unassign: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            },
            selectedClient :{
                required: true
            }
        },

        methods: {
            isAssigned(clientId, dutiesClients){
                if(!!dutiesClients.length){
                    return dutiesClients.map(item => item.id).includes(clientId);
                } 
            },
            dutyColorStatus(client, clients){
            if(!this.isAssigned(client, clients)) return 'table-success';
        },
        }
    }
</script>